import { Spacer } from '@vinted/web-ui'
import { ReactNode } from 'react'

type Props = {
  children: ReactNode
}

const VerticalPadder = ({ children }: Props) => {
  return (
    <div className="u-flexbox">
      <Spacer size="large" orientation="vertical" />
      {children}
      <Spacer size="large" orientation="vertical" />
    </div>
  )
}

export default VerticalPadder
